/* @ts-self-types="./gonkbox_emu.d.ts" */

export class BinaryTokenMapping {
    static __wrap(ptr) {
        const obj = Object.create(BinaryTokenMapping.prototype);
        obj.__wbg_ptr = ptr;
        BinaryTokenMappingFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BinaryTokenMappingFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_binarytokenmapping_free(ptr, 0);
    }
}
if (Symbol.dispose) BinaryTokenMapping.prototype[Symbol.dispose] = BinaryTokenMapping.prototype.free;

export class EmuError {
    static __wrap(ptr) {
        const obj = Object.create(EmuError.prototype);
        obj.__wbg_ptr = ptr;
        EmuErrorFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        EmuErrorFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_emuerror_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    format() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.emuerror_format(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_description() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.emuerror_get_description(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {EmuErrorType}
     */
    get_error_type() {
        const ret = wasm.emuerror_get_error_type(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) EmuError.prototype[Symbol.dispose] = EmuError.prototype.free;

/**
 * @enum {0 | 1}
 */
export const EmuErrorType = Object.freeze({
    OutOfBoundsException: 0, "0": "OutOfBoundsException",
    InstructionReadFailed: 1, "1": "InstructionReadFailed",
});

export class GonkASMToken {
    static __wrap(ptr) {
        const obj = Object.create(GonkASMToken.prototype);
        obj.__wbg_ptr = ptr;
        GonkASMTokenFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof GonkASMToken)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GonkASMTokenFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gonkasmtoken_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get line() {
        const ret = wasm.__wbg_get_gonkasmtoken_line(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get range_end() {
        const ret = wasm.__wbg_get_gonkasmtoken_range_end(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get range_start() {
        const ret = wasm.__wbg_get_gonkasmtoken_range_start(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {GonkASMTokenType}
     */
    get token_type() {
        const ret = wasm.__wbg_get_gonkasmtoken_token_type(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get value() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_gonkasmtoken_value(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get_line() {
        const ret = wasm.gonkasmtoken_get_line(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get_range_end() {
        const ret = wasm.gonkasmtoken_get_range_end(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get_range_start() {
        const ret = wasm.gonkasmtoken_get_range_start(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {string} value
     * @param {GonkASMTokenType} token_type
     * @param {number} line
     * @param {number} range_start
     * @param {number} range_end
     */
    constructor(value, token_type, line, range_start, range_end) {
        const ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.gonkasmtoken_new(ptr0, len0, token_type, line, range_start, range_end);
        this.__wbg_ptr = ret;
        GonkASMTokenFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {number} arg0
     */
    set line(arg0) {
        wasm.__wbg_set_gonkasmtoken_line(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set range_end(arg0) {
        wasm.__wbg_set_gonkasmtoken_range_end(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set range_start(arg0) {
        wasm.__wbg_set_gonkasmtoken_range_start(this.__wbg_ptr, arg0);
    }
    /**
     * @param {GonkASMTokenType} arg0
     */
    set token_type(arg0) {
        wasm.__wbg_set_gonkasmtoken_token_type(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set value(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_gonkasmtoken_value(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) GonkASMToken.prototype[Symbol.dispose] = GonkASMToken.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}
 */
export const GonkASMTokenType = Object.freeze({
    Command: 0, "0": "Command",
    Instruction: 1, "1": "Instruction",
    RamBracket: 2, "2": "RamBracket",
    Separator: 3, "3": "Separator",
    Label: 4, "4": "Label",
    Register: 5, "5": "Register",
    Identifier: 6, "6": "Identifier",
    ImmediateLiteral: 7, "7": "ImmediateLiteral",
    StringLiteral: 8, "8": "StringLiteral",
    StringLiteralEscape: 9, "9": "StringLiteralEscape",
    Macro: 10, "10": "Macro",
});

export class GonkBoxEmu {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GonkBoxEmuFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gonkboxemu_free(ptr, 0);
    }
    fmt_memory() {
        wasm.gonkboxemu_fmt_memory(this.__wbg_ptr);
    }
    /**
     * @returns {number}
     */
    get_bill() {
        const ret = wasm.gonkboxemu_get_bill(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get_canada() {
        const ret = wasm.gonkboxemu_get_canada(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get_charlie() {
        const ret = wasm.gonkboxemu_get_charlie(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint8Array}
     */
    get_memory() {
        const ret = wasm.gonkboxemu_get_memory(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {number}
     */
    get_microwave() {
        const ret = wasm.gonkboxemu_get_microwave(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get_paul() {
        const ret = wasm.gonkboxemu_get_paul(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get_register_text() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.gonkboxemu_get_register_text(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get_tim() {
        const ret = wasm.gonkboxemu_get_tim(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */
    is_executing() {
        const ret = wasm.gonkboxemu_is_executing(this.__wbg_ptr);
        return ret !== 0;
    }
    constructor() {
        const ret = wasm.gonkboxemu_new();
        this.__wbg_ptr = ret;
        GonkBoxEmuFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {string | undefined}
     */
    step() {
        const ret = wasm.gonkboxemu_step(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    stop_executing() {
        wasm.gonkboxemu_stop_executing(this.__wbg_ptr);
    }
    /**
     * @returns {number | undefined}
     */
    try_read() {
        const ret = wasm.gonkboxemu_try_read(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
     * @param {number} byte
     * @returns {boolean}
     */
    try_write(byte) {
        const ret = wasm.gonkboxemu_try_write(this.__wbg_ptr, byte);
        return ret !== 0;
    }
    /**
     * @param {ProgramBinary} binary
     */
    upload_program(binary) {
        _assertClass(binary, ProgramBinary);
        wasm.gonkboxemu_upload_program(this.__wbg_ptr, binary.__wbg_ptr);
    }
}
if (Symbol.dispose) GonkBoxEmu.prototype[Symbol.dispose] = GonkBoxEmu.prototype.free;

export class Instruction {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InstructionFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_instruction_free(ptr, 0);
    }
}
if (Symbol.dispose) Instruction.prototype[Symbol.dispose] = Instruction.prototype.free;

export class LinkedProgramMap {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LinkedProgramMapFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_linkedprogrammap_free(ptr, 0);
    }
}
if (Symbol.dispose) LinkedProgramMap.prototype[Symbol.dispose] = LinkedProgramMap.prototype.free;

export class ParseError {
    static __wrap(ptr) {
        const obj = Object.create(ParseError.prototype);
        obj.__wbg_ptr = ptr;
        ParseErrorFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ParseErrorFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_parseerror_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get_description() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.parseerror_get_description(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {GonkASMToken | undefined}
     */
    get_token() {
        const ret = wasm.parseerror_get_token(this.__wbg_ptr);
        return ret === 0 ? undefined : GonkASMToken.__wrap(ret);
    }
}
if (Symbol.dispose) ParseError.prototype[Symbol.dispose] = ParseError.prototype.free;

export class ProgramBinary {
    static __wrap(ptr) {
        const obj = Object.create(ProgramBinary.prototype);
        obj.__wbg_ptr = ptr;
        ProgramBinaryFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProgramBinaryFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_programbinary_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array}
     */
    get_binary_blob() {
        const ret = wasm.programbinary_get_binary_blob(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {BinaryTokenMapping[]}
     */
    get_binary_token_map() {
        const ret = wasm.programbinary_get_binary_token_map(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    get_start_byte() {
        const ret = wasm.programbinary_get_start_byte(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) ProgramBinary.prototype[Symbol.dispose] = ProgramBinary.prototype.free;

export class Tokenizer {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TokenizerFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tokenizer_free(ptr, 0);
    }
    /**
     * @returns {GonkASMToken[]}
     */
    build() {
        const ret = wasm.tokenizer_build(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {GonkASMToken[]}
     */
    get_tokens() {
        const ret = wasm.tokenizer_get_tokens(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {string} source
     */
    constructor(source) {
        const ptr0 = passStringToWasm0(source, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.tokenizer_new(ptr0, len0);
        this.__wbg_ptr = ret;
        TokenizerFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) Tokenizer.prototype[Symbol.dispose] = Tokenizer.prototype.free;

export class TokenizerError {
    static __wrap(ptr) {
        const obj = Object.create(TokenizerError.prototype);
        obj.__wbg_ptr = ptr;
        TokenizerErrorFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TokenizerErrorFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tokenizererror_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get_error() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.tokenizererror_get_error(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get_line() {
        const ret = wasm.tokenizererror_get_line(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) TokenizerError.prototype[Symbol.dispose] = TokenizerError.prototype.free;

/**
 * @param {GonkASMToken[]} tokens
 * @returns {ProgramBinary}
 */
export function buildGonkASMProgram(tokens) {
    const ptr0 = passArrayJsValueToWasm0(tokens, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.buildGonkASMProgram(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ProgramBinary.__wrap(ret[0]);
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_throw_9c31b086c2b26051: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_binarytokenmapping_new: function(arg0) {
            const ret = BinaryTokenMapping.__wrap(arg0);
            return ret;
        },
        __wbg_emuerror_new: function(arg0) {
            const ret = EmuError.__wrap(arg0);
            return ret;
        },
        __wbg_gonkasmtoken_new: function(arg0) {
            const ret = GonkASMToken.__wrap(arg0);
            return ret;
        },
        __wbg_gonkasmtoken_unwrap: function(arg0) {
            const ret = GonkASMToken.__unwrap(arg0);
            return ret;
        },
        __wbg_log_4cbcd7013d59af3a: function(arg0, arg1) {
            console.log(getStringFromWasm0(arg0, arg1));
        },
        __wbg_parseerror_new: function(arg0) {
            const ret = ParseError.__wrap(arg0);
            return ret;
        },
        __wbg_tokenizererror_new: function(arg0) {
            const ret = TokenizerError.__wrap(arg0);
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("TokenizerError")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./gonkbox_emu_bg.js": import0,
    };
}

const BinaryTokenMappingFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_binarytokenmapping_free(ptr, 1));
const EmuErrorFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_emuerror_free(ptr, 1));
const GonkASMTokenFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_gonkasmtoken_free(ptr, 1));
const GonkBoxEmuFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_gonkboxemu_free(ptr, 1));
const InstructionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_instruction_free(ptr, 1));
const LinkedProgramMapFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_linkedprogrammap_free(ptr, 1));
const ParseErrorFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_parseerror_free(ptr, 1));
const ProgramBinaryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_programbinary_free(ptr, 1));
const TokenizerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tokenizer_free(ptr, 1));
const TokenizerErrorFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tokenizererror_free(ptr, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('gonkbox_emu_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
